<section class="access_content">
  <section class="cards">
    <div class="card">
      {{ 'new_entries.requests_for_access_to_documents' | translate }}
    </div>
  </section>
  <section class="body">
    <section class="filters" *ngIf="filteredRequests?.length">
      <mat-form-field>
        <mat-select [(value)]="selectedRequestFilter" (selectionChange)="filterRequests()" panelClass="filter">
          <mat-option *ngFor="let req_type of request_filters" [value]="req_type.value">{{ req_type.viewValue
            }}</mat-option>
        </mat-select>
      </mat-form-field>
    </section>

    <!-- Add zero-state section -->
    <div class="zero-state" *ngIf="!filteredRequests?.length">
      <h5>{{ 'app.you_dont_have_any_requests' | translate }}</h5>
    </div>

    <!-- Show table only when there are requests -->
    <section class="table" *ngIf="filteredRequests?.length">
      <!-- Custom Templates for app-table -->
      <ng-template #requestDateTemplate let-row>
        {{ row.requestDate | localTime }}
      </ng-template>

      <ng-template #auditLogTemplate let-row>
        <button (click)="openViewLogs(row.originalData, row.originalData.institutionId != user.institutionId)">
          {{ 'new_entries.view_logs' | translate }}
        </button>
      </ng-template>

      <ng-template #statusTemplate let-row>
        <button *ngIf="row.originalData.institutionId == user.institutionId" class="other_institution">
          <mat-slide-toggle (change)="changeAccess(row.originalData.id, row.originalData.status)"
            [ngModel]="row.originalData.status" [checked]="row.originalData.status" color="primary">
            {{ (row.originalData.status ? 'new_entries.approved' : 'new_entries.revoked') | translate }}
          </mat-slide-toggle>
        </button>
        <button *ngIf="!row.originalData.status && row.originalData.institutionId != user.institutionId"
          class="your_institution revoked">
          {{ 'new_entries.revoked' | translate }}
        </button>
        <button *ngIf="row.originalData.status && row.originalData.institutionId != user.institutionId"
          class="your_institution approved">
          {{ 'new_entries.approved' | translate }}
        </button>
      </ng-template>

      <!-- App Table Component -->
      <app-table [columns]="tableColumns" [data]="mappedRequests" [paginatedData]="mappedRequests" [customTemplates]="{
          requestDateTemplate: requestDateTemplate,
          auditLogTemplate: auditLogTemplate,
          statusTemplate: statusTemplate
        }" [hasCheckboxes]="false">
      </app-table>
    </section>
  </section>
</section>